import { jsx as _jsx } from "react/jsx-runtime";
import { useMergeRefs } from '@floating-ui/react';
import { forwardRef, useContext } from 'react';
import { MenuContext } from '../Menu';
import { SvgIcon } from '../SvgIcon';
import { MenuItem } from './MenuItem';
import { iconTriangleLeft, iconTriangleRight } from '../../assets/icons';
export const MenuNestedItem = forwardRef(function MenuNestedItem(props, forwardedRef) {
    const { ...other } = props;
    const menuContext = useContext(MenuContext);
    const handleRef = useMergeRefs([menuContext.triggerRef, forwardedRef]);
    return (_jsx(MenuItem, { leadingIcon: menuContext.placement?.startsWith('left-') ? (_jsx(SvgIcon, { icon: iconTriangleLeft })) : undefined, trailingIcon: menuContext.placement?.startsWith('left-') ? undefined : (_jsx(SvgIcon, { icon: iconTriangleRight })), keepOpenOnClick: true, ...other, ...menuContext.getTriggerProps(), ref: handleRef }));
});
